// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Poppins.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

* {
  font-family: "Poppins", sans-serif !important;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* width */
::-webkit-scrollbar {
  width: 8px !important;
}

.ant-table-container::-webkit-scrollbar {
  height: 8px !important;
}

/* Handle */
::-webkit-scrollbar-thumb,
.ant-table-container::-webkit-scrollbar-thumb {
  background: #00008f !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover,
.ant-table-container::-webkit-scrollbar-thumb:hover {
  background: #002e71 !important;
}

.ant-table-container {
  scrollbar-width: thin;
  scrollbar-color: #00008f #f1f1f1;
  overflow: auto !important;
  height: 500px;
}

.ant-table-container:hover {
  scrollbar-color: #002e71 #f1f1f1;
}

.ant-table-thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
}

main {
  overflow: hidden !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.layout-container {
  min-height: 100vh !important;
}

.ant-layout {
  background-color: #fff !important;
}

.auth-layout-header {
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-layout-header {
  padding: 0;
  background: #fff;
  box-shadow: inset 0 -1px 0 #f0f0f0;
}

.auth-layout-content {
  padding: 0 48px;
}

.ant-divider-vertical {
  height: 45px;
  border-inline-start: 2px solid #ddd;
}

.dashboard-layout-content {
  padding: 24px;
  min-height: 280px;
  margin-left: 250px;
}

.dashboard-layout-content:has(#not-found),
.dashboard-layout-content:has(#welcome) {
  padding: 0;
}

.ant-layout .ant-layout-sider-zero-width-trigger {
  top: 0;
}

.sidebar {
  position: fixed !important;
  overflow: hidden auto;
  height: calc(100vh - 64px);
  left: 0;
  top: 64px;
  bottom: 0;
  flex: 0 0 250px !important;
  max-width: 250px !important;
  min-width: 250px !important;
  width: 250px !important;
  background: #fff !important;
  box-shadow: -5px 0px 10px 1px rgba(0, 0, 0, 0.6);
}

.notifications {
  line-height: 0;
  cursor: pointer;
  background-color: #00008f;
}

body:has(.ant-layout-sider-collapsed) .sidebar {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  flex: 0 0 80px !important;
}

body:has(.ant-layout-sider-collapsed) .dashboard-layout-content {
  margin-left: 80px !important;
}

body:has(.ant-layout-sider-collapsed) .banner {
  margin-left: 104px !important;
}

.collapse-icon {
  position: inherit;
  cursor: pointer;
  margin-left: 10px;
  font-size: large;
  color: #00008f;
}

body:has(.ant-layout-sider-collapsed) .collapse-icon {
  margin-left: 16px;
}

.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo {
  width: 52px;
  height: 52px;
  /* Logo removed for demo */
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-right: 8px;
}

.logo-title {
  font-size: 20px;
  font-weight: 600;
  color: #00008f;
  font-family: 'Poppins', sans-serif;
}

.text-center {
  text-align: center;
}

.ant-tabs-nav-operations {
  display: none !important;
}

.data-card .ant-card-head {
  background: url('https://img.freepik.com/free-vector/minimal-geometric-stripe-shape-background_1409-1014.jpg?size=626&ext=jpg&ga=GA1.1.735520172.1710374400&semt=ais') !important;
  color: #fff;
}

.welcome-card {
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.welcome-card:where(.css-dev-only-do-not-override-1k979oh).ant-card-hoverable:hover {
  box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;
  -webkit-box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;
  -moz-box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;
}

.welcome-card .ant-row {
  padding: 10px;
}

.welcome-card .ant-image {
  height: 100%;
  box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);
}

.float-delete {
  right: 170px
}

.float-edit {
  right: 94px;
}

.sidebar .ant-menu {
  padding: 15px 0 50px 0;
}

.sidebar .ant-menu-title-content,
.ant-btn {
  font-size: 13px;
}

.sidebar .ant-menu-item,
.sidebar .ant-menu-submenu-title {
  margin: 0 !important;
}

.sidebar .ant-menu-item-selected {
  margin: 0 !important;
  border-radius: unset !important;
  width: 100% !important;
  background: #00008f !important;
  color: #fff !important;
}

.sidebar .ant-menu-item-selected:before {
  content: "";
  display: block;
  width: 6px;
  background: #d24723;
  position: absolute;
  height: 30px;
  top: 50%;
  left: 0;
  border-radius: 0px 10px 10px 0px;
  transform: translateY(-50%);
  transition: all 0.2s linear;
}

.sidebar .ant-menu-item-only-child .ant-menu-title-content {
  font-size: 12px;
}

.sidebar .ant-menu-item-icon {
  font-size: 1.3rem !important;
}

.ant-btn-icon-only .ant-btn-icon {
  line-height: 2;
  font-size: 14px;
}

.sidebar .ant-menu-sub {
  background: transparent !important;
}

.ant-table-thead th {
  color: #b5b5c3 !important;
}

.ant-table-content,
.ant-table-header,
.ant-table-body {
  font-size: 12px;
  color: #3f4254;
}

.ant-card-head-title {
  font-size: 14px !important;
}

/* Master and mapping tabs */
.nav-tabs>.ant-tabs-nav:nth-of-type(1) {
  width: 100% !important;
}

.nav-tabs>.ant-tabs-nav:nth-of-type(1) .ant-tabs-tab {
  display: block;
  flex: 1 1;
  text-align: center;
  color: #00008f;
}

.nav-tabs>.ant-tabs-nav>div:nth-of-type(1) {
  display: unset !important;
  width: 100% !important;
}

.ant-tabs-ink-bar {
  background: #d24723 !important;
}

/* END master and mapping tabs */

/* Breathe animation */
.info {
  border-radius: 50%;
  background-color: #00008f;
  animation: breathe 3s linear infinite;
}

@keyframes breathe {
  0% {
    box-shadow: 0 0 0 6px rgb(1, 56, 136, .3)
  }
}

@keyframes zizo {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1.25, 1.25);
  }

  100% {
    transform: scale(1, 1);
  }
}

.ant-divider-horizontal {
  margin: 10px 0;
}

.nav-horizontal .ant-menu-item {
  color: #00008f !important;
  letter-spacing: 0.0625rem;
}

.nav-horizontal .ant-menu-item:hover::after {
  border-bottom-color: #d24723 !important;
  border-bottom-width: 3px !important;
}

.nav-horizontal .ant-menu-item-selected::after {
  border: none !important;
}

/* Start Table styles */
.ant-table-thead .ant-table-cell {
  color: #00008f !important;
  background: transparent !important;
  border-bottom: #d24723 solid 3px !important;
}

.ant-table-cell {
  padding: 8px 16px !important;
}

/* End Table styles */

/* Start Vertical Tabs Hide */
.manager:has(.hide-tabs) .ant-tabs-nav,
.input-manager:has(.hide-tabs) .ant-tabs-nav {
  display: none;
}

.manager:has(.hide-tabs) .ant-tabs-content-holder,
.input-manager:has(.hide-tabs) .ant-tabs-content-holder {
  border-left: none;
}

/* End Vertical Tabs Hide */

body:has(.anticon-vertical-align-top) .float-plus {
  right: 94px !important;
}

body:has(.anticon-vertical-align-top) .float-group {
  right: 164px !important;
}

/* Start informations styles */
#informations .ant-skeleton {
  width: 100%;
}

/* End informations styles */

.chart-container {
  height: 40vh
}

.react-flow__attribution {
  display: none !important;
}

.react-flow__node {
  word-break: break-word;
}

#workflow-details .ant-table-container {
  height: -moz-fit-content;
  height: fit-content;
}

.react-flow__node-default.selectable:hover {
  border: #d24723 1px solid;
}

.table-generator-header-action {
  cursor: pointer;
  float: right;
  margin-bottom: 10px;
}

.footer-divider {
  background-color: #222424;
  margin: 0;
}

.footer-content {
  background-color: #222424;
  color: #c0c2c5;
  padding: 14px 50px;
  z-index: 1;
}

.by-satoripop {
  color: #c0c2c5;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAmD;AACrD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;;EAEE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,OAAO;EACP,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iLAAiL;EACjL,WAAW;AACb;;AAEA;EACE,mHAAmH;AACrH;;AAEA;EACE,6DAA6D;EAC7D,qEAAqE;EACrE,kEAAkE;AACpE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,4DAA4D;EAC5D,yDAAyD;AAC3D;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gCAAgC;;AAEhC,sBAAsB;AACtB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB;;AAErB,6BAA6B;AAC7B;;EAEE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,2BAA2B;;AAE3B;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;AACb;;AAEA,4BAA4B;;AAE5B;EACE;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["@font-face {\n  font-family: 'Poppins';\n  src: url('./assets/Poppins.ttf') format('truetype');\n}\n\n* {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 8px !important;\n}\n\n.ant-table-container::-webkit-scrollbar {\n  height: 8px !important;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb,\n.ant-table-container::-webkit-scrollbar-thumb {\n  background: #00008f !important;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover,\n.ant-table-container::-webkit-scrollbar-thumb:hover {\n  background: #002e71 !important;\n}\n\n.ant-table-container {\n  scrollbar-width: thin;\n  scrollbar-color: #00008f #f1f1f1;\n  overflow: auto !important;\n  height: 500px;\n}\n\n.ant-table-container:hover {\n  scrollbar-color: #002e71 #f1f1f1;\n}\n\n.ant-table-thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #fff;\n}\n\nmain {\n  overflow: hidden !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.layout-container {\n  min-height: 100vh !important;\n}\n\n.ant-layout {\n  background-color: #fff !important;\n}\n\n.auth-layout-header {\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dashboard-layout-header {\n  padding: 0;\n  background: #fff;\n  box-shadow: inset 0 -1px 0 #f0f0f0;\n}\n\n.auth-layout-content {\n  padding: 0 48px;\n}\n\n.ant-divider-vertical {\n  height: 45px;\n  border-inline-start: 2px solid #ddd;\n}\n\n.dashboard-layout-content {\n  padding: 24px;\n  min-height: 280px;\n  margin-left: 250px;\n}\n\n.dashboard-layout-content:has(#not-found),\n.dashboard-layout-content:has(#welcome) {\n  padding: 0;\n}\n\n.ant-layout .ant-layout-sider-zero-width-trigger {\n  top: 0;\n}\n\n.sidebar {\n  position: fixed !important;\n  overflow: hidden auto;\n  height: calc(100vh - 64px);\n  left: 0;\n  top: 64px;\n  bottom: 0;\n  flex: 0 0 250px !important;\n  max-width: 250px !important;\n  min-width: 250px !important;\n  width: 250px !important;\n  background: #fff !important;\n  box-shadow: -5px 0px 10px 1px rgba(0, 0, 0, 0.6);\n}\n\n.notifications {\n  line-height: 0;\n  cursor: pointer;\n  background-color: #00008f;\n}\n\nbody:has(.ant-layout-sider-collapsed) .sidebar {\n  width: 80px !important;\n  min-width: 80px !important;\n  max-width: 80px !important;\n  flex: 0 0 80px !important;\n}\n\nbody:has(.ant-layout-sider-collapsed) .dashboard-layout-content {\n  margin-left: 80px !important;\n}\n\nbody:has(.ant-layout-sider-collapsed) .banner {\n  margin-left: 104px !important;\n}\n\n.collapse-icon {\n  position: inherit;\n  cursor: pointer;\n  margin-left: 10px;\n  font-size: large;\n  color: #00008f;\n}\n\nbody:has(.ant-layout-sider-collapsed) .collapse-icon {\n  margin-left: 16px;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.logo {\n  width: 52px;\n  height: 52px;\n  /* Logo removed for demo */\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  margin-right: 8px;\n}\n\n.logo-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #00008f;\n  font-family: 'Poppins', sans-serif;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.ant-tabs-nav-operations {\n  display: none !important;\n}\n\n.data-card .ant-card-head {\n  background: url('https://img.freepik.com/free-vector/minimal-geometric-stripe-shape-background_1409-1014.jpg?size=626&ext=jpg&ga=GA1.1.735520172.1710374400&semt=ais') !important;\n  color: #fff;\n}\n\n.welcome-card {\n  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);\n}\n\n.welcome-card:where(.css-dev-only-do-not-override-1k979oh).ant-card-hoverable:hover {\n  box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;\n  -webkit-box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;\n  -moz-box-shadow: 7px 9px 23px -10px rgba(0, 0, 0, 0.75) !important;\n}\n\n.welcome-card .ant-row {\n  padding: 10px;\n}\n\n.welcome-card .ant-image {\n  height: 100%;\n  box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 10px 10px 18px -13px rgba(0, 0, 0, 0.75);\n}\n\n.float-delete {\n  right: 170px\n}\n\n.float-edit {\n  right: 94px;\n}\n\n.sidebar .ant-menu {\n  padding: 15px 0 50px 0;\n}\n\n.sidebar .ant-menu-title-content,\n.ant-btn {\n  font-size: 13px;\n}\n\n.sidebar .ant-menu-item,\n.sidebar .ant-menu-submenu-title {\n  margin: 0 !important;\n}\n\n.sidebar .ant-menu-item-selected {\n  margin: 0 !important;\n  border-radius: unset !important;\n  width: 100% !important;\n  background: #00008f !important;\n  color: #fff !important;\n}\n\n.sidebar .ant-menu-item-selected:before {\n  content: \"\";\n  display: block;\n  width: 6px;\n  background: #d24723;\n  position: absolute;\n  height: 30px;\n  top: 50%;\n  left: 0;\n  border-radius: 0px 10px 10px 0px;\n  transform: translateY(-50%);\n  transition: all 0.2s linear;\n}\n\n.sidebar .ant-menu-item-only-child .ant-menu-title-content {\n  font-size: 12px;\n}\n\n.sidebar .ant-menu-item-icon {\n  font-size: 1.3rem !important;\n}\n\n.ant-btn-icon-only .ant-btn-icon {\n  line-height: 2;\n  font-size: 14px;\n}\n\n.sidebar .ant-menu-sub {\n  background: transparent !important;\n}\n\n.ant-table-thead th {\n  color: #b5b5c3 !important;\n}\n\n.ant-table-content,\n.ant-table-header,\n.ant-table-body {\n  font-size: 12px;\n  color: #3f4254;\n}\n\n.ant-card-head-title {\n  font-size: 14px !important;\n}\n\n/* Master and mapping tabs */\n.nav-tabs>.ant-tabs-nav:nth-of-type(1) {\n  width: 100% !important;\n}\n\n.nav-tabs>.ant-tabs-nav:nth-of-type(1) .ant-tabs-tab {\n  display: block;\n  flex: 1;\n  text-align: center;\n  color: #00008f;\n}\n\n.nav-tabs>.ant-tabs-nav>div:nth-of-type(1) {\n  display: unset !important;\n  width: 100% !important;\n}\n\n.ant-tabs-ink-bar {\n  background: #d24723 !important;\n}\n\n/* END master and mapping tabs */\n\n/* Breathe animation */\n.info {\n  border-radius: 50%;\n  background-color: #00008f;\n  animation: breathe 3s linear infinite;\n}\n\n@keyframes breathe {\n  0% {\n    box-shadow: 0 0 0 6px rgb(1, 56, 136, .3)\n  }\n}\n\n@keyframes zizo {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1.25, 1.25);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n.ant-divider-horizontal {\n  margin: 10px 0;\n}\n\n.nav-horizontal .ant-menu-item {\n  color: #00008f !important;\n  letter-spacing: 0.0625rem;\n}\n\n.nav-horizontal .ant-menu-item:hover::after {\n  border-bottom-color: #d24723 !important;\n  border-bottom-width: 3px !important;\n}\n\n.nav-horizontal .ant-menu-item-selected::after {\n  border: none !important;\n}\n\n/* Start Table styles */\n.ant-table-thead .ant-table-cell {\n  color: #00008f !important;\n  background: transparent !important;\n  border-bottom: #d24723 solid 3px !important;\n}\n\n.ant-table-cell {\n  padding: 8px 16px !important;\n}\n\n/* End Table styles */\n\n/* Start Vertical Tabs Hide */\n.manager:has(.hide-tabs) .ant-tabs-nav,\n.input-manager:has(.hide-tabs) .ant-tabs-nav {\n  display: none;\n}\n\n.manager:has(.hide-tabs) .ant-tabs-content-holder,\n.input-manager:has(.hide-tabs) .ant-tabs-content-holder {\n  border-left: none;\n}\n\n/* End Vertical Tabs Hide */\n\nbody:has(.anticon-vertical-align-top) .float-plus {\n  right: 94px !important;\n}\n\nbody:has(.anticon-vertical-align-top) .float-group {\n  right: 164px !important;\n}\n\n/* Start informations styles */\n#informations .ant-skeleton {\n  width: 100%;\n}\n\n/* End informations styles */\n\n.chart-container {\n  height: 40vh\n}\n\n.react-flow__attribution {\n  display: none !important;\n}\n\n.react-flow__node {\n  word-break: break-word;\n}\n\n#workflow-details .ant-table-container {\n  height: fit-content;\n}\n\n.react-flow__node-default.selectable:hover {\n  border: #d24723 1px solid;\n}\n\n.table-generator-header-action {\n  cursor: pointer;\n  float: right;\n  margin-bottom: 10px;\n}\n\n.footer-divider {\n  background-color: #222424;\n  margin: 0;\n}\n\n.footer-content {\n  background-color: #222424;\n  color: #c0c2c5;\n  padding: 14px 50px;\n  z-index: 1;\n}\n\n.by-satoripop {\n  color: #c0c2c5;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
